import React from "react";
import { createPortal } from "react-dom";
import "../styles/policyModal.css";

interface PolicyModalProps {
  isOpen: boolean;
  title: string;
  body: string;
  onClose: () => void;
}

const PolicyModal: React.FC<PolicyModalProps> = ({
  isOpen,
  title,
  body,
  onClose,
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="policy-modal-overlay" onClick={onClose}>
      <div
        className="policy-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="policy-modal-header">
          <h2>{title}</h2>

          <button
            type="button"
            className="policy-modal-close"
            onClick={onClose}
            aria-label="Close policy modal"
          >
            ×
          </button>
        </div>

        <div
          className="policy-modal-body"
          dangerouslySetInnerHTML={{ __html: body }}
        />

        <div className="policy-modal-footer">
          <button type="button" className="policy-modal-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default PolicyModal;
